var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilePicker',{attrs:{"buttons":_vm.buttons,"container":null,"name":_vm.t('files', 'Select file or folder to link to'),"multiselect":false},on:{"close":function($event){return _vm.$emit('cancel')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }